import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { TopicSpecialist } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../services';
import { VolunteeringAreaService } from '../../../volunteering-area.service';
import { VolunteeringSpecialistsService } from '../../volunteering-specialists.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'not-approved-specialists-by-topic-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './not-approved-specialists-by-topic.part.html',
})
export class NotApprovedSpecialistsByTopicViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	public readonly areaService = inject(VolunteeringAreaService);
	private readonly pageService = inject(VolunteeringSpecialistsService);
	private readonly dialogService = inject(DialogService);
	private readonly domain = inject(DomainDataService);
	private readonly app = inject(AppService);

	public setup = getSetup(this.areaService, this.util, this.dialogService, this.domain, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	ngOnInit() {
		this.areaService.getVolunteeringData();
	}

	public notApprovedSpecialistsByTopic = computed<TopicSpecialist[]>(() => {
		const data = this.areaService.volunteeringData();
		if (!data) return [];

		const topicsMap = this.util.array.toMap(this.domain.data().topics.filter(t => t.needsSpecialist), t => t.topicId);

		// Creating a map of volunteers for quick access with volunteerId as key
		const volunteers = this.util.array.toMap(data.volunteers, v => v.volunteerId);

		const signUpsCountByTrimesterMap = this.areaService.specialistSignUpsCountMapByTrimester;

		return data.volunteerTopics.filter(t => !t.isApproved).map(t => {
			const volunteer = volunteers[t.volunteerId];
			const topic = topicsMap[t.topicId];

			if (!volunteer || !topic) return null

			return {
				topicId: t.topicId,
				topicName: topic.name,
				isTopicEnabled: topic.enabled,
				volunteerId: t.volunteerId,
				volunteerStatusId: volunteer.volunteerStatusId,
				volunteerPerson: volunteer.person,
				signUpsCount: signUpsCountByTrimesterMap[t.volunteerId] || { currentTrimester: 0, nextTrimester: 0 },
				updatedUTC: volunteer.updatedUTC,
				assignedToStaffId: volunteer.assignedToStaffId,
				attendedOrientation: volunteer.attendedOrientation,
				hasEnVideo: volunteer.hasEnVideo,
				hasEsVideo: volunteer.hasEsVideo,
				handbookSigned: volunteer.handbookSigned,
				mediaConsentSigned: volunteer.mediaConsentSigned,
				agreementsSigned: volunteer.agreementsSigned,
				interviewDateUTC: volunteer.interviewDateUTC,
			};
		}).filter(t => t !== null);
	});

}